import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Dexoresto: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi restoran dexoposresto" />
    <h1><strong><a href="/dexoresto/">Aplikasi Restoran Dexopos resto apps</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/KUsp5Rzk9Nc" title="aplikasi restoran"></iframe>
</div>
    <p>
Kemudahan dalam all in one app bekerja dengan dexopos resto ini, <a href="/dexoresto/">aplikasi restoran</a> memudahkan dalam berbagai kebutuhan di dalam nya, semakin smepurna dengan website yang terintegrasi secara penuh dengan aplikasi restoran, bekerja via desktop mode dan dukungan mobile waiters memudahkan dalam kebutuhan untuk transaksi kasir, pencatatan pesanan waiters dan cek laporan income secara detail, dukungan website lengkap untuk homepage, about page, gallery , event promosi agenda contact dan lain nya.
    </p>
  
    <div className="embed-responsive embed-responsive-4by3 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/FCm4ijsw5FE" title="aplikasi restoran android kasir shop"></iframe>
</div>
    <p>Sentuh kemudahan aplikasi android APK untuk bekerja semakin mobile dalam kebutuhan bertransaksi via web apps ini untuk digunakan.</p>
<div className="container">
<div className="row">
<div className="col-lg-6">
<h3 className="mb-5">Pricing Dexopos resto Apps</h3>
<p>Daftar harga layanan per tahun sesuai package set</p>
</div>
</div>
<div className="row">
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-primary text-white text-center p-3">Basic</p>
<br />
<p>Dexopos resto Apps</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>500MB Web Space</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-primary text-white"><strong>Rp.1.052.600</strong>
</p>
<br /> <a className="btn btn-primary" href=" https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3ADexoposresto-Basic%0APrice%20%3ARp.1.052.600/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-danger text-white text-center p-3">Premium</p>
<br />
<p>Dexopos resto Apps</p>
<hr />
<p>Free domain .com</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>Website Premium Pack</p>
<hr />
<p>1.5GB Web Space</p>
<hr />
<p>APK Android Backend</p>
<hr />
<p>APK Android Frontend</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-danger text-white"><strong>Rp.3.264.800</strong>
</p>
<br /> <a className="btn btn-danger" href=" https://wa.me/6285646104747?text=Axcorasapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%3ADexoposresto-Premium%0APrice%20%3ARp.3.264.800/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
<div className="col-lg-4 col-sm-6 text-center">
<div className="card card-plain card-blog shadow rounded p-3">
<div className="card-body px-0">
<p className="lead border bg-info text-white text-center p-3">Standard</p>
<br />
<p>Dexopos resto Apps</p>
<hr />
<p>Free domain .com</p>
<hr />
<p>Clouds Host</p>
<hr />
<p>CMS Website</p>
<hr />
<p>500MB Web Space</p>
<hr />
<p>APK Android Backend</p>
<hr />
<p>Layanan Bantuan</p>
<hr />
<p>Layanan Konsultasi</p>
<br />
<p className="lead p-3 bg-info text-white"><strong>Rp.1.561.200</strong>
</p>
<br /> <a className="btn btn-info text-white" href=" https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20%Dexoposresto-Standard%0APrice%20%3ARp.1.561.200/tahun%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya ">Order Now </a>
</div>
</div>
</div>
</div>
</div>

<Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Dexoresto

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
